import React from "react"
import { Grid, Typography } from "@mui/material"
import Pin from "../../assets/icons/pin.svg"
import CustomButton from "../../components/custom-button/custom-button.component"
import CustomLink from "../../components/custom-link/custom-link.component"

import * as S from "./open-positions.styles"

const OpenPositions = ({
  title,
  positions,
  bestPlacesCard,
  noPositionsImage,
}) => {
  const { description, logos } = bestPlacesCard

  return (
    <S.Section>
      <S.Wrapper>
        <S.Title>{title}</S.Title>

        <Grid
          container
          spacing={3}
          style={
            positions?.length > 0
              ? { justifyContent: "flex-start" }
              : { justifyContent: "center" }
          }
        >
          {positions?.length > 0 ? (
            positions?.map(({ position, place, link }, index) => (
              <Grid item xs={12} md={6} key={`${position}-${index}`}>
                <S.CardContainer>
                  <S.TopContainer>
                    <S.Position>{position}</S.Position>
                    <S.Place>
                      <Pin />
                      <Typography>{place}</Typography>
                    </S.Place>
                  </S.TopContainer>
                  <CustomButton
                    className="lightBorder"
                    style={{ height: "52px" }}
                    href={link.url}
                  >
                    {link?.title}
                  </CustomButton>
                </S.CardContainer>
              </Grid>
            ))
          ) : (
            <>
              <Grid item xs={12}>
                <div>
                  <S.Text>There are currently no open positions.</S.Text>{" "}
                  <S.NoOpenImage img={noPositionsImage.sourceUrl} />
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <S.BestPlacesCard>
                  <S.Description>{description}</S.Description>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                  >
                    {logos?.map(({ image, link }, index) => (
                      <Grid
                        item
                        sm={3}
                        key={`logo-${index}`}
                        justifyContent="center"
                      >
                        <a href={link.url} target="_blank">
                          <S.Image img={image} />
                        </a>
                      </Grid>
                    ))}
                  </Grid>
                </S.BestPlacesCard>
              </Grid>
            </>
          )}
        </Grid>
      </S.Wrapper>
    </S.Section>
  )
}

export default OpenPositions
